// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"MintModal_buttonWrapper__Osrb2","button":"MintModal_button__qGkFa"};